import img1 from "../assets/images/corousel_1.jpeg";
import img2 from "../assets/images/corousel_2.jpeg";
import img3 from "../assets/images/corousel_3.jpeg";
import img4 from "../assets/images/corousel_4.jpeg";
import img5 from "../assets/images/corousel_5.jpeg";
import img6 from "../assets/images/corousel_6.jpeg";
import img7 from "../assets/images/corousel_7.jpeg";

const CorouselImages = [img1, img2, img3, img4, img5, img6, img7];


export default CorouselImages;


